<template>
    <structure>
        <section class="ouvidoria">
            <div class="title">
                <div>
                    <h1>Meus Chamados</h1>
                    <p>Abra os seus chamados e um de nossos atendentes irá te responder.</p>
                </div>
            </div>
            <div class="page-control">
                <div>
                    <div class="tabs">
                        <ul>
                            <li>
                                <button type="button" :class="filter == null ? 'active' : ''" @click="setfilter(null)">Todos</button>
                            </li>
                            <li>
                                <button type="button" :class="filter == 'new' ? 'active' : ''" @click="setfilter('new')">Novos</button>
                            </li>
                            <li>
                                <button type="button" :class="filter == 'progress' ? 'active' : ''" @click="setfilter('progress')">Em andamento</button>
                            </li>
                            <li>
                                <button type="button" :class="filter == 'closed' ? 'active' : ''" @click="setfilter('closed')">Finalizados</button>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-if="isPermission('tickets_add')">
                    <button type="button" @click="modal('modal', 'add-ticket')">Abrir novo chamado <i class="fal fa-plus"></i></button>
                </div>
            </div>
            
            <div class="list">
                <div class="list-content">
                    <table v-if="!load">
                        <thead>
                            <th width="80">Código</th>
                            <th width="80">Cliente</th>
                            <th width="100">Status</th>
                            <th>Assunto</th>
                            <th width="210" class="mh">Última atualização</th>
                            <th width="80" class="mh">Responsável</th>
                            <th width="10" v-if="isPermissions('ticket_edit,ticket_delete,ticket_edit_status,ticket_edit_owner')"></th>
                            <th width="10"></th>
                        </thead>
                        <tbody>
                            <tr v-for="(ticket, index) in tickets" :key="ticket.id">
                                <td>{{ticket.code}}</td>
                                <td>
                                    <img :src="ticket.client.avatar">
                                </td>
                                <td>
                                    <span class="tag progress" v-status="ticket.status"></span>
                                </td>
                                <td>{{ticket.title}}</td>
                                <td><i class="fal fa-calendar-alt"></i> {{ticket.created_at | moment('DD/MM/YYYY [às] hh:mm')}}</td>
                                <td>
                                    <img :src="ticket.owner.avatar" v-if="ticket.owner">
                                    <div class="text-center" v-if="!ticket.owner">-</div>
                                </td>
                                <td v-if="isPermissions('ticket_edit,ticket_delete,ticket_edit_status,ticket_edit_owner')">
                                    <ui-menu-action>
                                        <li v-if="isPermission('ticket_edit')">
                                            <button type="button" @click="edit(ticket, index)">Editar</button>
                                        </li>
                                        <li v-if="isPermission('ticket_delete')">
                                            <button type="button" @click="removeModal(ticket, index)">Excluir</button>
                                        </li>
                                        <li v-if="isPermission('ticket_edit_status')">
                                            <button type="button" @click="updateStatus(ticket, index)">Alterar Status</button>
                                        </li>
                                        <li v-if="isPermission('ticket_edit_owner')">
                                            <button type="button"  @click="addResponsible(ticket, index)">Alterar responsável</button>
                                        </li>
                                    </ui-menu-action>
                                </td>
                                <td>
                                    <button type="button" class="btn-show" @click="goTo(ticket.id)"><i class="fal fa-long-arrow-right"></i></button>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot v-if="ispagination">
                            <tr>
                                <td colspan="8">
                                    <div class="pagination">
                                        <button type="button" :class="reloadIndicator" @click="pagination()" v-if="ispagination">Carregar mais</button>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <section class="load" v-if="load"></section>
            </div>
        </section>
        <ui-modal-add  :ticket="ticket" />
        <ui-modal-add-responsible :ticket="ticket" />
        <ui-modal-status :ticket="ticket" />
        <ui-modal-delete :ticket="ticket" />
    </structure>
</template>

<script>
    import structure from '@/templates/private'
    import uiModalAdd from './modal-add'
    import uiModalAddResponsible from './modal-add-responsible'
    import uiModalStatus from './modal-add-status'
    import uiModalDelete from './modal-delete'
    import { tickets } from '@/services'
    import { uiMenuAction } from '@/components'
    import { status } from '@/directives'
    import permissions from '@/mixins/permissions'
    export default {
        components: { structure, uiModalAdd, uiModalAddResponsible, uiMenuAction, uiModalStatus, uiModalDelete },
        directives: { status },
        mixins: [ permissions ],
        data() {
            return {
                tickets: [],
                total: 0,
                load: true,
                reload: false,
                statusModal: false,
                ticket: null,
                filter: null,
                page: 1,
                pages: null,
            }
        },
        methods: {
            goTo(id){
                this.$router.push({ path: '/ouvidoria/'+id })
            },
            modal(action, id){
                this.ticket = {
                    title: '',
                    text: '',
                }
                this.$root.$emit(action, id);
            },
            list(){
                this.reload = true
                let paramsFilter    = this.filter ? '&status=' + this.filter : ''
                let paramsPage      =  '?page=' + this.page
                let params          = paramsPage + paramsFilter
                tickets.list(params).then( response => {
                    this.tickets = [...this.tickets, ...response.data.rows]
                    this.reload = false
                    this.load = false
                    this.total = response.data.total
                    this.pages = response.data.pages
                })
            },
            removeModal(ticket, index){
                this.ticket = ticket
                this.ticket.index = index
                this.$root.$emit('modal', 'remove-ticket');
            },
            addResponsible(ticket, index){
                this.$root.$emit('modal', 'add-responsible');
                this.ticket = ticket
                this.ticket.index = index

            },
            updateStatus(ticket, index){
                this.$root.$emit('modal', 'update-status');
                this.ticket = ticket
                this.ticket.index = index

            },
            edit(ticket, index){
                this.$root.$emit('modal', 'add-ticket');
                this.ticket = ticket
                this.ticket.index = index

            },
            expireEdit(d){
                let start   = this.$moment(d).add(10, 'm').format('DD/MM/YYYY HH:mm:ss')
                let end     = this.$moment().format('DD/MM/YYYY HH:mm:ss')
                return end > start ? false : true
            },
            setfilter(status){
                this.filter = status
                this.load = true
                this.tickets = []
                this.page = 1
                this.list()
            },
            
            pagination(){
                if(this.page >= this.pages) return false 
                this.page++
                this.list()
            }
        },
        computed: {
            ispagination(){
                return this.page < this.pages ? true : false
            },
            reloadIndicator(){
                return this.reload ? 'loading' : ''
            }
        },
        created(){
            this.list()
            this.$root.$on("remove-item", (index) => {
                this.modal('modal-close', 'remove-ticket')
                this.$delete(this.tickets, index)
            })
            this.$root.$on("add-item", (row) => {
                this.modal('modal-close', 'add-ticket')
                this.tickets.unshift(row)
                this.ticket = {
                    title: '',
                    text: '',
                }
            })
            this.$root.$on("update-list", (row) => {
                this.modal('modal-close', 'add-ticket')
                this.$set(this.tickets[row.index], 'title', row.title)
                this.$set(this.tickets[row.index], 'text', row.text)
                this.ticket = {
                    title: '',
                    text: '',
                }
            })
            this.$root.$on("update-item", (row) => {
                this.modal('modal-close', 'add-responsible')
                this.$set(this.tickets[row.index], 'owner', row.owner)
                this.ticket = {
                    title: '',
                    text: '',
                }
            })
            this.$root.$on("update-item-status", (row) => {
                this.modal('modal-close', 'update-status')
                this.$set(this.tickets[row.index], 'status', row.status)
                this.ticket = {
                    title: '',
                    text: '',
                }
            })
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
